import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
  loadingContainer: {
    padding: "1.6em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  customLoaderWrapper: {
    width: "100vw",
    height: "100vh",
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#fff",
  },
  pageLoaderImg: {
    width: 150,
  },
}));
